import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../helpers/reselectHelpers';
import {
  makeGetConversationSelection,
  makeGetOnlySelectedConversation,
} from '../../store/panels/cells/selectors/cellsPanelSelectionSelectors';
import {ViewerPanelId} from '../../store/panels/panelStateBase';
import {ViewerPanelPagesState} from '../../store/panels/viewer/viewerPanelState';
import {PopupViewerConversation} from './popupViewerConversation';

/*
 * Props.
 */

interface PopupViewerConversationContainerProps {
  panelId: ViewerPanelId;
  pages: ViewerPanelPagesState;
}

/*
 * Selectors.
 */

function getPage(_state: unknown, props: PopupViewerConversationContainerProps) {
  return props.pages.current;
}

function getInboxesParameters(_state: unknown, props: PopupViewerConversationContainerProps) {
  return props.pages.current.parameters;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<PopupViewerConversationContainerProps>()(() => {
  const getConversationSelection = makeGetConversationSelection(getInboxesParameters);

  return {
    page: getPage,
    conversationSelection: getConversationSelection,
    conversation: makeGetOnlySelectedConversation(getConversationSelection),
  };
});

export const PopupViewerConversationContainer = connect(mapStateToProps)(PopupViewerConversation);
